module.exports = __webpack_public_path__ + "img/Vector.7c5506de.svg";